export default "__VITE_ASSET__B0l8UTQE__"